import { render } from "./ModalInputBuzzerNumber.vue?vue&type=template&id=eafd5cb2&scoped=true"
import script from "./ModalInputBuzzerNumber.vue?vue&type=script&lang=js"
export * from "./ModalInputBuzzerNumber.vue?vue&type=script&lang=js"

import "./ModalInputBuzzerNumber.vue?vue&type=style&index=0&id=eafd5cb2&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eafd5cb2"]])

export default __exports__